import { useContext } from 'react';
import { StateContext } from 'context.js';

export const useGlobalState = () => {
    const [state, dispatch] = useContext(StateContext);

    let dispatcherObj = {};

    dispatcherObj.setAccessToken = function (token) {
        dispatch({ type: 'SET_ACCESSTOKEN', payload: token });
    };

    dispatcherObj.refreshFileBrowser = function () {
        dispatch({ type: 'REFRESH', payload: null });
    };

    dispatcherObj.refreshUserBrowser = function () {
        dispatch({ type: 'REFRESH', payload: null });
    };

    dispatcherObj.refreshCurrentFolder = function (fileListObj) {
        dispatch({ type: 'SET_TREE_OBJ', payload: fileListObj });
        if (state.currentPath.length === 1) {
            dispatch({
                type: 'SET_CURRENT_ITEMS',
                payload: Object.keys(fileListObj[state.currentPath[0]]),
            });
        } else if (state.currentPath.length === 2) {
            dispatch({
                type: 'SET_CURRENT_ITEMS',
                payload: Object.keys(fileListObj[state.currentPath[0]][state.currentPath[1]]),
            });
        } else if (state.currentPath.length === 3) {
            dispatch({
                type: 'SET_CURRENT_ITEMS',
                payload:
                    fileListObj[state.currentPath[0]][state.currentPath[1]][state.currentPath[2]],
            });
        }
    };

    dispatcherObj.setTreeObj = function (fileListObj) {
        dispatch({ type: 'SET_TREE_OBJ', payload: fileListObj });
        dispatch({ type: 'SET_CURRENT_PATH', payload: [] });
        dispatch({ type: 'SET_CURRENT_ITEMS', payload: Object.keys(fileListObj) });
    };

    dispatcherObj.setCurrentPath = function (newPath) {
        dispatch({ type: 'SET_CURRENT_PATH', payload: newPath });
        if (newPath.length !== 3) {
            dispatch({ type: 'SET_SELECTED_FILE', payload: {name: null} });
        }
        if (newPath.length === 0) {
            dispatch({ type: 'SET_CURRENT_ITEMS', payload: Object.keys(state.treeObj) });
        } else if (newPath.length === 1) {
            dispatch({
                type: 'SET_CURRENT_ITEMS',
                payload: Object.keys(state.treeObj[newPath[0]]),
            });
        } else if (newPath.length === 2) {
            dispatch({
                type: 'SET_CURRENT_ITEMS',
                payload: Object.keys(state.treeObj[newPath[0]][newPath[1]]),
            });
        } else if (newPath.length === 3) {
            dispatch({
                type: 'SET_CURRENT_ITEMS',
                payload: state.treeObj[newPath[0]][newPath[1]][newPath[2]],
            });
        }
    };

    dispatcherObj.setBusy = function (newState) {
        dispatch({ type: 'SET_BUSY_STATE', payload: newState });
    };

    dispatcherObj.setUsers = function (users) {
        dispatch({ type: 'SET_USERS', payload: users });
    };

    dispatcherObj.setSelectedFile = function (filename) {
        dispatch({ type: 'SET_SELECTED_FILE', payload: filename });
    };

    dispatcherObj.setSelectedUser = function (username) {
        dispatch({ type: 'SET_SELECTED_USER', payload: username });
    };

    dispatcherObj.setRememberSelectedFile = function (newState) {
        dispatch({ type: 'SEARCH_REDIRECT', payload: newState });
    };

    dispatcherObj.setAnalyticsFile = function (file) {
        dispatch({ type: 'SET_ANALYTICS_FILE', payload: file });
    };

    return [state, dispatcherObj];
};
